.color-picker {
  &__swatch {
    padding: 5px;
    background: var(--color-bg-primary);
    border-radius: var(--radius-md);
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
    display: inline-block;
    cursor: pointer;

    .color-picker__color {
      height: 24px;
      width: 24px;
      border-radius: 2px;
    }
  }
}
